import React, { Component } from 'react';
import Page from '../pages/Page';
import ProfileContainer from '../containers/Bookkeeping';
import {injectIntl} from 'react-intl';

class Profile extends Component {
  getMetaData() {
    return {
      title: this.pageTitle(),
      meta: this.pageMeta(),
      link: this.pageLink()
    };
  }

  pageTitle = () => {
    return this.props.intl.formatMessage({id: 'bookkeeping.pageTitle'});
  };

  pageMeta = () => {
    return [
      { name: 'description', content: this.props.intl.formatMessage({id: 'bookkeeping.pageDescription'}) }
    ];
  };

  pageLink = () => {
    return [];
  };

  componentDidMount () {
    const paddleScript = document.createElement("script");

    paddleScript.src = "https://cdn.paddle.com/paddle/paddle.js";
    document.head.appendChild(paddleScript);

    paddleScript.onload = ()=>{
      const paddelInitScript = document.createElement("script");
      paddelInitScript.async =  true;
      paddelInitScript.innerHTML = `Paddle.Setup({
        vendor: 30421
      });`
    

      document.body.appendChild(paddelInitScript);
    }
  }

  render() {
    return (
      <Page {...this.getMetaData()}>
        <ProfileContainer {...this.props} />
      </Page>
    );
  }
}

export default injectIntl(Profile);




// WEBPACK FOOTER //
// app/pages/Bookkeeping.jsx